module.exports = __webpack_public_path__ + "img/notification.724b4dde.webp";